import { useId } from 'react';
import type { FormInputProps } from './interfaces';

export function useInput({
  id,
  error,
  message,
  validation,
  onChange,
  onValueChange,
}: FormInputProps) {
  const uid = useId();
  const inputId = id ?? `inp-${uid}`;

  const finalMessage = error ?? message;
  const finalValidation = error ? 'error' : validation;

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange?.(e);
    onValueChange?.(e.target.value);
  };
  return { inputId, finalMessage, finalValidation, handleChange };
}
